import React from 'react';
// import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import Footer from './Footer';
import "../styles/NavMenu.css";
import "../styles/custom.css";

export default function Layout(props) {

    return (
        <div>
            <NavMenu />
            {/* <Container tag="main"> */}
            <div className="main-content">
                {props.children}
                <Footer />
            </div>
            {/* </Container> */}
        </div>
    );

}